import Header from "../Header";
import Footer from "../Footer";
import Breadcrumbs from "../Breadcrumbs";
import BannerImg from "../assets/Images/banner-1920x450.png";

import BottomLogoImg from "../assets/Images/bottom-logo.png";
import PdfLogoImg from "../assets/Images/pdf.png";
import "./ArbitrationSocietyRulesPage.scss";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { UncontrolledCollapse, Button, CardBody, Card } from "reactstrap";

const ArbitrationSocietyRulesPage = () => {
  const { t } = useTranslation();

  return (
    <>
      <Header />
      <div className="banner">
        <img src={BannerImg} alt="" />
        <div className="banner_title res">
          <h1 className="banner-main-title">
            {t("arbitration_society_rules_page_header")}
          </h1>
          <p className="banner-subtitle">
            {t("arbitration_society_rules_page_header2")}
          </p>
        </div>
      </div>
      <Breadcrumbs>
        <Link>{t("breadcrumbs_arbitration_society_rules_page_link1")}</Link>
        <span>{t("breadcrumbs_arbitration_society_rules_page_span")}</span>
        <Link>{t("breadcrumbs_arbitration_society_rules_page_link2")}</Link>
      </Breadcrumbs>
      <main className="rules-main-container">
        <section className="rules-header-section">
          <h2 className="rules-section-title">
            {t("hong_kong_arbitration_society_rules")}
          </h2>
        </section>
        <section className="rules-content-section">
          <div className="item">
            <Button
              id="toggler"
              style={{
                marginLeft: "20px",
                marginBottom: "1rem",
                marginTop: "1rem",
                backgroundColor: "white",
                border: "none",
                color: "gray",
                borderLeft: "10px solid #790b1b",
                borderRadius: "0px",
                height: "20px",
                paddingTop: "0px",
                width: "100%",
                textAlign: "start",
              }}
            >
              {t("arbitration_society_rules_introduction")}
            </Button>
            <UncontrolledCollapse toggler="#toggler">
              <Card>
                <CardBody className={"text-justify"}>
                  <p className="mb-3">
                    {t("arbitration_society_rules_introduction_text1")}
                  </p>
                </CardBody>
              </Card>
            </UncontrolledCollapse>
          </div>
          <div className="item">
            <Button
              id="toggler1"
              style={{
                marginLeft: "20px",
                marginBottom: "1rem",
                backgroundColor: "white",
                border: "none",
                color: "gray",
                borderLeft: "10px solid #790b1b",
                borderRadius: "0px",
                height: "20px",
                paddingTop: "0px",
                width: "100%",
                textAlign: "start",
              }}
            >
              {t("arbitration_society_rules_application")}
            </Button>
            <UncontrolledCollapse toggler="#toggler1">
              <Card>
                <CardBody className={"text-justify"}>
                  <ul>
                    <li>
                      <p className="mb-3">
                        {t("arbitration_society_rules_application_text1")}
                      </p>
                    </li>
                  </ul>
                </CardBody>
              </Card>
            </UncontrolledCollapse>
          </div>
          <div className="item">
            <Button
              id="toggler2"
              style={{
                marginLeft: "20px",
                marginBottom: "1rem",
                backgroundColor: "white",
                border: "none",
                color: "gray",
                borderLeft: "10px solid #790b1b",
                borderRadius: "0px",
                height: "20px",
                paddingTop: "0px",
                width: "100%",
                textAlign: "start",
              }}
            >
              {t("arbitration_society_rules_effectivness")}
            </Button>
            <UncontrolledCollapse toggler="#toggler2">
              <Card>
                <CardBody className={"text-justify"}>
                  <ul>
                    <li>
                      <p className="mb-3">
                        {t("arbitration_society_rules_effectivness_text1")}
                      </p>
                    </li>
                  </ul>
                </CardBody>
              </Card>
            </UncontrolledCollapse>
          </div>
          <div className="item">
            <Button
              id="toggler3"
              style={{
                marginLeft: "20px",
                marginBottom: "1rem",
                backgroundColor: "white",
                border: "none",
                color: "gray",
                borderLeft: "10px solid #790b1b",
                borderRadius: "0px",
                height: "20px",
                paddingTop: "0px",
                width: "100%",
                textAlign: "start",
              }}
            >
              {t("arbitration_society_rules_suggested_clauses")}
            </Button>
            <UncontrolledCollapse toggler="#toggler3">
              <Card>
                <CardBody className={"text-justify"}>
                  <p className="mb-3">
                    {t("arbitration_society_rules_suggested_clauses_text1")}
                  </p>
                  <p className="mb-3">
                    {t("arbitration_society_rules_suggested_clauses_text2")}
                  </p>
                  <p className="mb-3">
                    {t("arbitration_society_rules_suggested_clauses_text3")}
                  </p>
                  <p className="mb-3">
                    {t("arbitration_society_rules_suggested_clauses_text4")}
                  </p>
                  <p className="mb-3">
                    {t("arbitration_society_rules_suggested_clauses_text5")}
                  </p>
                  <p className="mb-3">
                    {t("arbitration_society_rules_suggested_clauses_text6")}
                  </p>
                  <p className="mb-3">
                    {t("arbitration_society_rules_suggested_clauses_text7")}
                  </p>
                  <p className="mb-3">
                    {t("arbitration_society_rules_suggested_clauses_text8")}
                  </p>
                  <p className="mb-3">
                    {t("arbitration_society_rules_suggested_clauses_text9")}
                  </p>
                </CardBody>
              </Card>
            </UncontrolledCollapse>
          </div>
          <div className="item">
            <Button
              id="toggler4"
              style={{
                marginLeft: "20px",
                marginBottom: "1rem",
                backgroundColor: "white",
                border: "none",
                color: "gray",
                borderLeft: "10px solid #790b1b",
                borderRadius: "0px",
                height: "20px",
                paddingTop: "0px",
                width: "100%",
                textAlign: "start",
              }}
            >
              {t("arbitration_society_rules_article1")}
            </Button>
            <UncontrolledCollapse toggler="#toggler4">
              <Card>
                <CardBody className={"text-justify"}>
                  <p className="mb-3">
                    {t("arbitration_society_rules_article1_text1")}
                  </p>
                  <p className="mb-3">
                    {t("arbitration_society_rules_article1_text2")}
                  </p>
                  <p className="mb-3">
                    {t("arbitration_society_rules_article1_text3")}
                  </p>
                  <p className="mb-3">
                    {t("arbitration_society_rules_article1_text4")}
                  </p>
                  <p className="mb-3">
                    {t("arbitration_society_rules_article1_text5")}
                  </p>
                </CardBody>
              </Card>
            </UncontrolledCollapse>
          </div>
          <div className="item">
            <Button
              id="toggler5"
              style={{
                marginLeft: "20px",
                marginBottom: "1rem",
                backgroundColor: "white",
                border: "none",
                color: "gray",
                borderLeft: "10px solid #790b1b",
                borderRadius: "0px",
                height: "20px",
                paddingTop: "0px",
                width: "100%",
                textAlign: "start",
              }}
            >
              {t("arbitration_society_rules_article2")}
            </Button>
            <UncontrolledCollapse toggler="#toggler5">
              <Card>
                <CardBody className={"text-justify"}>
                  <p className="mb-3">
                    {t("arbitration_society_rules_article2_text1")}
                  </p>
                  <p className="mb-3">
                    {t("arbitration_society_rules_article2_text2")}
                  </p>
                  <ul className="list">
                    <p>{t("arbitration_society_rules_article2_text3")}</p>
                    <p>{t("arbitration_society_rules_article2_text4")}</p>
                    <p>{t("arbitration_society_rules_article2_text5")}</p>
                    <p>{t("arbitration_society_rules_article2_text6")}</p>
                  </ul>
                  <p className="mb-3 mt-3">
                    {t("arbitration_society_rules_article2_text7")}
                  </p>
                  <ul className="list">
                    <p>{t("arbitration_society_rules_article2_text8")}</p>
                    <p>{t("arbitration_society_rules_article2_text9")}</p>
                    <p>{t("arbitration_society_rules_article2_text10")}</p>
                  </ul>
                  <p className="mb-3 mt-3">
                    {t("arbitration_society_rules_article2_text11")}
                  </p>
                  <p className="mb-3">
                    {t("arbitration_society_rules_article2_text12")}
                  </p>
                </CardBody>
              </Card>
            </UncontrolledCollapse>
          </div>
          <div className="item">
            <Button
              id="toggler6"
              style={{
                marginLeft: "20px",
                marginBottom: "1rem",
                backgroundColor: "white",
                border: "none",
                color: "gray",
                borderLeft: "10px solid #790b1b",
                borderRadius: "0px",
                height: "20px",
                paddingTop: "0px",
                width: "100%",
                textAlign: "start",
              }}
            >
              {t("arbitration_society_rules_article3")}
            </Button>
            <UncontrolledCollapse toggler="#toggler6">
              <Card>
                <CardBody className={"text-justify"}>
                  <p className="mb-3">
                    {t("arbitration_society_rules_article3_text1")}
                  </p>
                  <p className="mb-3">
                    {t("arbitration_society_rules_article3_text2")}
                  </p>
                  <p className="mb-3">
                    {t("arbitration_society_rules_article3_text3")}
                  </p>
                  <p className="mb-3">
                    {t("arbitration_society_rules_article3_text4")}
                  </p>
                  <p className="mb-3">
                    {t("arbitration_society_rules_article3_text5")}
                  </p>
                </CardBody>
              </Card>
            </UncontrolledCollapse>
          </div>
          <div className="item">
            <Button
              id="toggler7"
              style={{
                marginLeft: "20px",
                marginBottom: "1rem",
                backgroundColor: "white",
                border: "none",
                color: "gray",
                borderLeft: "10px solid #790b1b",
                borderRadius: "0px",
                height: "20px",
                paddingTop: "0px",
                width: "100%",
                textAlign: "start",
              }}
            >
              {t("arbitration_society_rules_article4")}
            </Button>
            <UncontrolledCollapse toggler="#toggler7">
              <Card>
                <CardBody className={"text-justify"}>
                  <p className="mb-3">
                    {t("arbitration_society_rules_article4_text1")}
                  </p>
                  <p className="mb-3">
                    {t("arbitration_society_rules_article4_text2")}
                  </p>
                  <p className="mb-3">
                    {t("arbitration_society_rules_article4_text3")}
                  </p>
                  <p className="mb-3">
                    {t("arbitration_society_rules_article4_text4")}
                  </p>
                  <p className="mb-3">
                    {t("arbitration_society_rules_article4_text5")}
                  </p>
                  <p className="mb-3">
                    {t("arbitration_society_rules_article4_text6")}
                  </p>
                  <p className="mb-3">
                    {t("arbitration_society_rules_article4_text7")}
                  </p>
                  <p className="mb-3">
                    {t("arbitration_society_rules_article4_text8")}
                  </p>
                  <p className="mb-3">
                    {t("arbitration_society_rules_article4_text9")}
                  </p>
                  <p className="mb-3">
                    {t("arbitration_society_rules_article4_text10")}
                  </p>
                  <p className="mb-3">
                    {t("arbitration_society_rules_article4_text11")}
                  </p>
                  <p className="mb-3">
                    {t("arbitration_society_rules_article4_text12")}
                  </p>
                  <p className="mb-3">
                    {t("arbitration_society_rules_article4_text13")}
                  </p>
                  <p className="mb-3">
                    {t("arbitration_society_rules_article4_text14")}
                  </p>
                  <p className="mb-3">
                    {t("arbitration_society_rules_article4_text15")}
                  </p>
                  <p className="mb-3">
                    {t("arbitration_society_rules_article4_text16")}
                  </p>
                  <p className="mb-3">
                    {t("arbitration_society_rules_article4_text17")}
                  </p>
                  <p className="mb-3">
                    {t("arbitration_society_rules_article4_text18")}
                  </p>
                  <p className="mb-3">
                    {t("arbitration_society_rules_article4_text19")}
                  </p>
                </CardBody>
              </Card>
            </UncontrolledCollapse>
          </div>
          <div className="item">
            <Button
              id="toggler8"
              style={{
                marginLeft: "20px",
                marginBottom: "1rem",
                backgroundColor: "white",
                border: "none",
                color: "gray",
                borderLeft: "10px solid #790b1b",
                borderRadius: "0px",
                height: "20px",
                paddingTop: "0px",
                width: "100%",
                textAlign: "start",
              }}
            >
              {t("arbitration_society_rules_article5")}
            </Button>
            <UncontrolledCollapse toggler="#toggler8">
              <Card>
                <CardBody className={"text-justify"}>
                  <p className="mb-3">
                    {t("arbitration_society_rules_article5_text1")}
                  </p>
                  <p className="mb-3">
                    {t("arbitration_society_rules_article5_text2")}
                  </p>
                  <ul className="list">
                    <li>{t("arbitration_society_rules_article5_text3")}</li>
                    <li>{t("arbitration_society_rules_article5_text4")}</li>
                    <li>{t("arbitration_society_rules_article5_text5")}</li>
                    <li>{t("arbitration_society_rules_article5_text6")}</li>
                    <li>{t("arbitration_society_rules_article5_text7")}</li>
                    <li>{t("arbitration_society_rules_article5_text8")}</li>
                    <li>{t("arbitration_society_rules_article5_text9")}</li>
                    <li>{t("arbitration_society_rules_article5_text10")}</li>
                    <li>{t("arbitration_society_rules_article5_text11")}</li>
                    <li>{t("arbitration_society_rules_article5_text12")}</li>
                    <li>{t("arbitration_society_rules_article5_text13")}</li>
                  </ul>
                  <p className="mb-3">
                    {t("arbitration_society_rules_article5_text14")}
                  </p>
                  <p className="mb-3">
                    {t("arbitration_society_rules_article5_text15")}
                  </p>
                </CardBody>
              </Card>
            </UncontrolledCollapse>
          </div>
          <div className="item">
            <Button
              id="toggler9"
              style={{
                marginLeft: "20px",
                marginBottom: "1rem",
                backgroundColor: "white",
                border: "none",
                color: "gray",
                borderLeft: "10px solid #790b1b",
                borderRadius: "0px",
                height: "20px",
                paddingTop: "0px",
                width: "100%",
                textAlign: "start",
              }}
            >
              {t("arbitration_society_rules_article6")}
            </Button>
            <UncontrolledCollapse toggler="#toggler9">
              <Card>
                <CardBody className={"text-justify"}>
                  <p className="mb-3">
                    {t("arbitration_society_rules_article6_text1")}
                  </p>
                  <p className="mb-3">
                    {t("arbitration_society_rules_article6_text2")}
                  </p>
                  <ul className="list">
                    <li>{t("arbitration_society_rules_article6_text3")}</li>
                    <li>{t("arbitration_society_rules_article6_text4")}</li>
                    <li>{t("arbitration_society_rules_article6_text5")}</li>
                    <li>{t("arbitration_society_rules_article6_text6")}</li>
                    <li>{t("arbitration_society_rules_article6_text7")}</li>
                    <li>{t("arbitration_society_rules_article6_text8")}</li>
                    <li>{t("arbitration_society_rules_article6_text9")}</li>
                    <li>{t("arbitration_society_rules_article6_text10")}</li>
                    <li>{t("arbitration_society_rules_article6_text11")}</li>
                    <li>{t("arbitration_society_rules_article6_text12")}</li>
                  </ul>
                  <p className="mb-3">
                    {t("arbitration_society_rules_article6_text13")}
                  </p>
                  <p className="mb-3">
                    {t("arbitration_society_rules_article6_text14")}
                  </p>
                  <p className="mb-3">
                    {t("arbitration_society_rules_article6_text15")}
                  </p>
                </CardBody>
              </Card>
            </UncontrolledCollapse>
          </div>
          <div className="item">
            <Button
              id="toggler10"
              style={{
                marginLeft: "20px",
                marginBottom: "1rem",
                backgroundColor: "white",
                border: "none",
                color: "gray",
                borderLeft: "10px solid #790b1b",
                borderRadius: "0px",
                height: "20px",
                paddingTop: "0px",
                width: "100%",
                textAlign: "start",
              }}
            >
              {t("arbitration_society_rules_article7")}
            </Button>
            <UncontrolledCollapse toggler="#toggler10">
              <Card>
                <CardBody className={"text-justify"}>
                  <p className="mb-3">
                    {t("arbitration_society_rules_article7_text1")}
                  </p>
                  <p className="mb-3">
                    {t("arbitration_society_rules_article7_text2")}
                  </p>
                  <ul className="list">
                    <li>{t("arbitration_society_rules_article7_text3")}</li>
                    <li>{t("arbitration_society_rules_article7_text4")}</li>
                    <li>{t("arbitration_society_rules_article7_text5")}</li>
                    <li>{t("arbitration_society_rules_article7_text6")}</li>
                    <li>{t("arbitration_society_rules_article7_text7")}</li>
                    <li>{t("arbitration_society_rules_article7_text8")}</li>
                  </ul>
                  <p className="mb-3">
                    {t("arbitration_society_rules_article7_text9")}
                  </p>
                </CardBody>
              </Card>
            </UncontrolledCollapse>
          </div>
          <div className="item">
            <Button
              id="toggler11"
              style={{
                marginLeft: "20px",
                marginBottom: "1rem",
                backgroundColor: "white",
                border: "none",
                color: "gray",
                borderLeft: "10px solid #790b1b",
                borderRadius: "0px",
                height: "20px",
                paddingTop: "0px",
                width: "100%",
                textAlign: "start",
              }}
            >
              {t("arbitration_society_rules_article8")}
            </Button>
            <UncontrolledCollapse toggler="#toggler11">
              <Card>
                <CardBody className={"text-justify"}>
                  <p className="mb-3">
                    {t("arbitration_society_rules_article8_text1")}
                  </p>
                  <p className="mb-3">
                    {t("arbitration_society_rules_article8_text2")}
                  </p>
                </CardBody>
              </Card>
            </UncontrolledCollapse>
          </div>
          <div className="item">
            <Button
              id="toggler12"
              style={{
                marginLeft: "20px",
                marginBottom: "1rem",
                backgroundColor: "white",
                border: "none",
                color: "gray",
                borderLeft: "10px solid #790b1b",
                borderRadius: "0px",
                height: "20px",
                paddingTop: "0px",
                width: "100%",
                textAlign: "start",
              }}
            >
              {t("arbitration_society_rules_article9")}
            </Button>
            <UncontrolledCollapse toggler="#toggler12">
              <Card>
                <CardBody className={"text-justify"}>
                  <p className="mb-3">
                    {t("arbitration_society_rules_article9_text1")}
                  </p>
                  <p className="mb-3">
                    {t("arbitration_society_rules_article9_text2")}
                  </p>
                </CardBody>
              </Card>
            </UncontrolledCollapse>
          </div>
          <div className="item">
            <Button
              id="toggler13"
              style={{
                marginLeft: "20px",
                marginBottom: "1rem",
                backgroundColor: "white",
                border: "none",
                color: "gray",
                borderLeft: "10px solid #790b1b",
                borderRadius: "0px",
                height: "20px",
                paddingTop: "0px",
                width: "100%",
                textAlign: "start",
              }}
            >
              {t("arbitration_society_rules_article10")}
            </Button>
            <UncontrolledCollapse toggler="#toggler13">
              <Card>
                <CardBody className={"text-justify"}>
                  <p className="mb-3">
                    {t("arbitration_society_rules_article10_text1")}
                  </p>
                  <p className="mb-3">
                    {t("arbitration_society_rules_article10_text2")}
                  </p>
                  <p className="mb-3">
                    {t("arbitration_society_rules_article10_text3")}
                  </p>
                  <p className="mb-3">
                    {t("arbitration_society_rules_article10_text4")}
                  </p>
                  <p className="mb-3">
                    {t("arbitration_society_rules_article10_text5")}
                  </p>
                  <p className="mb-3">
                    {t("arbitration_society_rules_article10_text6")}
                  </p>
                  <p className="mb-3">
                    {t("arbitration_society_rules_article10_text7")}
                  </p>
                  <p className="mb-3">
                    {t("arbitration_society_rules_article10_text8")}
                  </p>
                  <p className="mb-3">
                    {t("arbitration_society_rules_article10_text9")}
                  </p>
                  <ul className="list">
                    <li>{t("arbitration_society_rules_article10_text10")}</li>
                    <li>​{t("arbitration_society_rules_article10_text11")}</li>
                    <li>{t("arbitration_society_rules_article10_text12")}</li>
                    <li>{t("arbitration_society_rules_article10_text13")}</li>
                    <li>{t("arbitration_society_rules_article10_text14")}</li>
                  </ul>
                  <p className="mb-3">
                    {t("arbitration_society_rules_article10_text15")}
                  </p>
                </CardBody>
              </Card>
            </UncontrolledCollapse>
          </div>
          <div className="item">
            <Button
              id="toggler14"
              style={{
                marginLeft: "20px",
                marginBottom: "1rem",
                backgroundColor: "white",
                border: "none",
                color: "gray",
                borderLeft: "10px solid #790b1b",
                borderRadius: "0px",
                height: "20px",
                paddingTop: "0px",
                width: "100%",
                textAlign: "start",
              }}
            >
              {t("arbitration_society_rules_article11")}
            </Button>
            <UncontrolledCollapse toggler="#toggler14">
              <Card>
                <CardBody className={"text-justify"}>
                  <p className="mb-3">
                    {t("arbitration_society_rules_article11_text1")}
                  </p>
                  <p className="mb-3">
                    {t("arbitration_society_rules_article11_text2")}
                  </p>
                  <p className="mb-3">
                    {t("arbitration_society_rules_article11_text3")}
                  </p>
                  <p className="mb-3">
                    {t("arbitration_society_rules_article11_text4")}
                  </p>
                  <p className="mb-3">
                    {t("arbitration_society_rules_article11_text5")}
                  </p>
                  <p className="mb-3">
                    {t("arbitration_society_rules_article11_text6")}
                  </p>
                </CardBody>
              </Card>
            </UncontrolledCollapse>
          </div>
          <div className="item">
            <Button
              id="toggler15"
              style={{
                marginLeft: "20px",
                marginBottom: "1rem",
                backgroundColor: "white",
                border: "none",
                color: "gray",
                borderLeft: "10px solid #790b1b",
                borderRadius: "0px",
                height: "20px",
                paddingTop: "0px",
                width: "100%",
                textAlign: "start",
              }}
            >
              {t("arbitration_society_rules_article12")}
            </Button>
            <UncontrolledCollapse toggler="#toggler15">
              <Card>
                <CardBody className={"text-justify"}>
                  <p className="mb-3">
                    {t("arbitration_society_rules_article12_text1")}
                  </p>
                  <p className="mb-3">
                    {t("arbitration_society_rules_article12_text2")}
                  </p>
                  <p className="mb-3">
                    {t("arbitration_society_rules_article12_text3")}
                  </p>
                </CardBody>
              </Card>
            </UncontrolledCollapse>
          </div>
          <div className="item">
            <Button
              id="toggler16"
              style={{
                marginLeft: "20px",
                marginBottom: "1rem",
                backgroundColor: "white",
                border: "none",
                color: "gray",
                borderLeft: "10px solid #790b1b",
                borderRadius: "0px",
                height: "20px",
                paddingTop: "0px",
                width: "100%",
                textAlign: "start",
              }}
            >
              {t("arbitration_society_rules_article13")}
            </Button>
            <UncontrolledCollapse toggler="#toggler16">
              <Card>
                <CardBody className={"text-justify"}>
                  <p className="mb-3">
                    {t("arbitration_society_rules_article13_text1")}
                  </p>
                  <p className="mb-3">
                    {t("arbitration_society_rules_article13_text2")}
                  </p>
                  <ul className="list">
                    <li>{t("arbitration_society_rules_article13_text3")}</li>
                    <li>​{t("arbitration_society_rules_article13_text4")}</li>
                    <li>{t("arbitration_society_rules_article13_text5")}</li>
                  </ul>
                  <p className="mb-3">
                    {t("arbitration_society_rules_article13_text6")}
                  </p>
                  <p className="mb-3">
                    {t("arbitration_society_rules_article13_text7")}
                  </p>
                  <p className="mb-3">
                    {t("arbitration_society_rules_article13_text8")}
                  </p>
                </CardBody>
              </Card>
            </UncontrolledCollapse>
          </div>
          <div className="item">
            <Button
              id="toggler17"
              style={{
                marginLeft: "20px",
                marginBottom: "1rem",
                backgroundColor: "white",
                border: "none",
                color: "gray",
                borderLeft: "10px solid #790b1b",
                borderRadius: "0px",
                height: "20px",
                paddingTop: "0px",
                width: "100%",
                textAlign: "start",
              }}
            >
              {t("arbitration_society_rules_article14")}
            </Button>
            <UncontrolledCollapse toggler="#toggler17">
              <Card>
                <CardBody className={"text-justify"}>
                  <p className="mb-3">
                    ​{t("arbitration_society_rules_article14_text1")}
                  </p>
                  <p className="mb-3">
                    ​{t("arbitration_society_rules_article14_text2")}
                  </p>
                  <p className="mb-3">
                    ​{t("arbitration_society_rules_article14_text3")}
                  </p>
                  <p className="mb-3">
                    ​{t("arbitration_society_rules_article14_text4")}
                  </p>
                  <p className="mb-3">
                    ​{t("arbitration_society_rules_article14_text5")}
                  </p>
                  <p className="mb-3">
                    ​{t("arbitration_society_rules_article14_text6")}
                  </p>
                </CardBody>
              </Card>
            </UncontrolledCollapse>
          </div>
          <div className="item">
            <Button
              id="toggler18"
              style={{
                marginLeft: "20px",
                marginBottom: "1rem",
                backgroundColor: "white",
                border: "none",
                color: "gray",
                borderLeft: "10px solid #790b1b",
                borderRadius: "0px",
                height: "20px",
                paddingTop: "0px",
                width: "100%",
                textAlign: "start",
              }}
            >
              {t("arbitration_society_rules_article15")}
            </Button>
            <UncontrolledCollapse toggler="#toggler18">
              <Card>
                <CardBody className={"text-justify"}>
                  <p className="mb-3">
                    ​{t("arbitration_society_rules_article15_text1")}
                  </p>
                  <p className="mb-3">
                    ​{t("arbitration_society_rules_article15_text2")}
                  </p>
                  <p className="mb-3">
                    ​{t("arbitration_society_rules_article15_text3")}
                  </p>
                  <p className="mb-3">
                    ​{t("arbitration_society_rules_article15_text4")}
                  </p>
                  <p className="mb-3">
                    ​{t("arbitration_society_rules_article15_text5")}
                  </p>
                  <p className="mb-3">
                    ​{t("arbitration_society_rules_article15_text6")}
                  </p>
                  <p className="mb-3">
                    ​{t("arbitration_society_rules_article15_text7")}
                  </p>
                  <p className="mb-3">
                    ​{t("arbitration_society_rules_article15_text8")}
                  </p>
                </CardBody>
              </Card>
            </UncontrolledCollapse>
          </div>
          <div className="item">
            <Button
              id="toggler19"
              style={{
                marginLeft: "20px",
                marginBottom: "1rem",
                backgroundColor: "white",
                border: "none",
                color: "gray",
                borderLeft: "10px solid #790b1b",
                borderRadius: "0px",
                height: "20px",
                paddingTop: "0px",
                width: "100%",
                textAlign: "start",
              }}
            >
              {t("arbitration_society_rules_article16")}
            </Button>
            <UncontrolledCollapse toggler="#toggler19">
              <Card>
                <CardBody className={"text-justify"}>
                  <p className="mb-3">
                    ​{t("arbitration_society_rules_article16_text1")}
                  </p>
                </CardBody>
              </Card>
            </UncontrolledCollapse>
          </div>
          <div className="item">
            <Button
              id="toggler20"
              style={{
                marginLeft: "20px",
                marginBottom: "1rem",
                backgroundColor: "white",
                border: "none",
                color: "gray",
                borderLeft: "10px solid #790b1b",
                borderRadius: "0px",
                height: "20px",
                paddingTop: "0px",
                width: "100%",
                textAlign: "start",
              }}
            >
              {t("arbitration_society_rules_article17")}
            </Button>
            <UncontrolledCollapse toggler="#toggler20">
              <Card>
                <CardBody className={"text-justify"}>
                  <p className="mb-3">
                    ​{t("arbitration_society_rules_article17_text1")}
                  </p>
                  <p className="mb-3">
                    ​{t("arbitration_society_rules_article17_text2")}
                  </p>
                  <p className="mb-3">
                    ​{t("arbitration_society_rules_article17_text3")}
                  </p>
                  <p className="mb-3">
                    ​{t("arbitration_society_rules_article17_text4")}
                  </p>
                  <p className="mb-3">
                    ​{t("arbitration_society_rules_article17_text5")}
                  </p>
                  <p className="mb-3">
                    ​{t("arbitration_society_rules_article17_text6")}
                  </p>
                  <p className="mb-3">
                    ​{t("arbitration_society_rules_article17_text7")}
                  </p>
                  <p className="mb-3">
                    ​{t("arbitration_society_rules_article17_text8")}
                  </p>
                  <p className="mb-3">
                    ​{t("arbitration_society_rules_article17_text9")}
                  </p>
                  <ul className="list">
                    <li>{t("arbitration_society_rules_article17_text10")}</li>
                    <li>​{t("arbitration_society_rules_article17_text11")}</li>
                    <li>{t("arbitration_society_rules_article17_text12")}</li>
                    <li>{t("arbitration_society_rules_article17_text13")}</li>
                    <ul className="list" style={{ marginLeft: "20px" }}>
                      <li>{t("arbitration_society_rules_article17_text14")}</li>
                      <li>
                        ​{t("arbitration_society_rules_article17_text15")}
                      </li>
                      <li>{t("arbitration_society_rules_article17_text16")}</li>
                      <li>{t("arbitration_society_rules_article17_text17")}</li>
                      <li>{t("arbitration_society_rules_article17_text18")}</li>
                      <li>{t("arbitration_society_rules_article17_text19")}</li>
                    </ul>
                    <li>{t("arbitration_society_rules_article17_text20")}</li>
                    <li>{t("arbitration_society_rules_article17_text21")}</li>
                  </ul>
                  <p className="mb-3">
                    ​{t("arbitration_society_rules_article17_text22")}
                  </p>
                  <p className="mb-3">
                    ​{t("arbitration_society_rules_article17_text23")}
                  </p>
                  <p className="mb-3">
                    ​{t("arbitration_society_rules_article17_text24")}
                  </p>
                  <p className="mb-3">
                    ​{t("arbitration_society_rules_article17_text25")}
                  </p>
                  <p className="mb-3">
                    ​{t("arbitration_society_rules_article17_text26")}
                  </p>
                </CardBody>
              </Card>
            </UncontrolledCollapse>
          </div>
          <div className="item">
            <Button
              id="toggler21"
              style={{
                marginLeft: "20px",
                marginBottom: "1rem",
                backgroundColor: "white",
                border: "none",
                color: "gray",
                borderLeft: "10px solid #790b1b",
                borderRadius: "0px",
                height: "20px",
                paddingTop: "0px",
                width: "100%",
                textAlign: "start",
              }}
            >
              {t("arbitration_society_rules_article18")}
            </Button>
            <UncontrolledCollapse toggler="#toggler21">
              <Card>
                <CardBody className={"text-justify"}>
                  <p className="mb-3">
                    ​{t("arbitration_society_rules_article18_text1")}
                  </p>
                </CardBody>
              </Card>
            </UncontrolledCollapse>
          </div>
          <div className="item">
            <Button
              id="toggler22"
              style={{
                marginLeft: "20px",
                marginBottom: "1rem",
                backgroundColor: "white",
                border: "none",
                color: "gray",
                borderLeft: "10px solid #790b1b",
                borderRadius: "0px",
                height: "20px",
                paddingTop: "0px",
                width: "100%",
                textAlign: "start",
              }}
            >
              {t("arbitration_society_rules_article19")}
            </Button>
            <UncontrolledCollapse toggler="#toggler22">
              <Card>
                <CardBody className={"text-justify"}>
                  <p className="mb-3">
                    ​{t("arbitration_society_rules_article19_text1")}
                  </p>
                  <p className="mb-3">
                    ​{t("arbitration_society_rules_article19_text2")}
                  </p>
                  <p className="mb-3">
                    ​{t("arbitration_society_rules_article19_text3")}
                  </p>
                  <p className="mb-3">
                    ​{t("arbitration_society_rules_article19_text4")}
                  </p>
                  <ul className="list">
                    <li>{t("arbitration_society_rules_article19_text5")}</li>
                    <li>​{t("arbitration_society_rules_article19_text6")}</li>
                    <li>{t("arbitration_society_rules_article19_text7")}</li>
                    <li>{t("arbitration_society_rules_article19_text8")}</li>
                  </ul>
                  <p className="mb-3">
                    ​{t("arbitration_society_rules_article19_text9")}
                  </p>
                  <ul className="list">
                    <li>{t("arbitration_society_rules_article19_text10")}</li>
                    <li>​{t("arbitration_society_rules_article19_text11")}</li>
                  </ul>
                  <p className="mb-3">
                    ​{t("arbitration_society_rules_article19_text12")}
                  </p>
                  <p className="mb-3">
                    ​{t("arbitration_society_rules_article19_text13")}
                  </p>
                  <p className="mb-3">
                    ​{t("arbitration_society_rules_article19_text14")}
                  </p>
                  <p className="mb-3">
                    ​{t("arbitration_society_rules_article19_text15")}
                  </p>
                </CardBody>
              </Card>
            </UncontrolledCollapse>
          </div>
          <div className="item">
            <Button
              id="toggler23"
              style={{
                marginLeft: "20px",
                marginBottom: "1rem",
                backgroundColor: "white",
                border: "none",
                color: "gray",
                borderLeft: "10px solid #790b1b",
                borderRadius: "0px",
                height: "20px",
                paddingTop: "0px",
                width: "100%",
                textAlign: "start",
              }}
            >
              {t("arbitration_society_rules_article20")}
            </Button>
            <UncontrolledCollapse toggler="#toggler23">
              <Card>
                <CardBody className={"text-justify"}>
                  <p className="mb-3">
                    ​{t("arbitration_society_rules_article20_text1")}
                  </p>
                  <p className="mb-3">
                    ​{t("arbitration_society_rules_article20_text2")}
                  </p>
                  <p className="mb-3">
                    ​{t("arbitration_society_rules_article20_text3")}
                  </p>
                  <p className="mb-3">
                    ​{t("arbitration_society_rules_article20_text4")}
                  </p>
                  <p className="mb-3">
                    ​{t("arbitration_society_rules_article20_text5")}
                  </p>
                  <p className="mb-3">
                    ​{t("arbitration_society_rules_article20_text6")}
                  </p>
                  <p className="mb-3">
                    ​{t("arbitration_society_rules_article20_text7")}
                  </p>
                  <p className="mb-3">
                    ​{t("arbitration_society_rules_article20_text8")}
                  </p>
                  <p className="mb-3">
                    ​{t("arbitration_society_rules_article20_text9")}
                  </p>
                  <p className="mb-3">
                    ​{t("arbitration_society_rules_article20_text10")}
                  </p>
                  <p className="mb-3">
                    ​{t("arbitration_society_rules_article20_text11")}
                  </p>
                </CardBody>
              </Card>
            </UncontrolledCollapse>
          </div>
          <div className="item">
            <Button
              id="toggler24"
              style={{
                marginLeft: "20px",
                marginBottom: "1rem",
                backgroundColor: "white",
                border: "none",
                color: "gray",
                borderLeft: "10px solid #790b1b",
                borderRadius: "0px",
                height: "20px",
                paddingTop: "0px",
                width: "100%",
                textAlign: "start",
              }}
            >
              {t("arbitration_society_rules_article21")}
            </Button>
            <UncontrolledCollapse toggler="#toggler24">
              <Card>
                <CardBody className={"text-justify"}>
                  <p className="mb-3">
                    ​{t("arbitration_society_rules_article21_text1")}
                  </p>
                  <p className="mb-3">
                    ​{t("arbitration_society_rules_article21_text2")}
                  </p>
                  <p className="mb-3">
                    ​{t("arbitration_society_rules_article21_text3")}
                  </p>
                </CardBody>
              </Card>
            </UncontrolledCollapse>
          </div>
          <div className="item">
            <Button
              id="toggler25"
              style={{
                marginLeft: "20px",
                marginBottom: "1rem",
                backgroundColor: "white",
                border: "none",
                color: "gray",
                borderLeft: "10px solid #790b1b",
                borderRadius: "0px",
                height: "20px",
                paddingTop: "0px",
                width: "100%",
                textAlign: "start",
              }}
            >
              {t("arbitration_society_rules_article22")}
            </Button>
            <UncontrolledCollapse toggler="#toggler25">
              <Card>
                <CardBody className={"text-justify"}>
                  <p className="mb-3">
                    ​{t("arbitration_society_rules_article22_text1")}
                  </p>
                  <p className="mb-3">
                    ​{t("arbitration_society_rules_article22_text2")}
                  </p>
                  <p className="mb-3">
                    ​{t("arbitration_society_rules_article22_text3")}
                  </p>
                  <p className="mb-3">
                    ​{t("arbitration_society_rules_article22_text4")}
                  </p>
                  <p className="mb-3">
                    ​{t("arbitration_society_rules_article22_text5")}
                  </p>
                </CardBody>
              </Card>
            </UncontrolledCollapse>
          </div>
          <div className="item">
            <Button
              id="toggler26"
              style={{
                marginLeft: "20px",
                marginBottom: "1rem",
                backgroundColor: "white",
                border: "none",
                color: "gray",
                borderLeft: "10px solid #790b1b",
                borderRadius: "0px",
                height: "20px",
                paddingTop: "0px",
                width: "100%",
                textAlign: "start",
              }}
            >
              {t("arbitration_society_rules_article23")}
            </Button>
            <UncontrolledCollapse toggler="#toggler26">
              <Card>
                <CardBody className={"text-justify"}>
                  <p className="mb-3">
                    ​{t("arbitration_society_rules_article23_text1")}
                  </p>
                  <p className="mb-3">
                    ​{t("arbitration_society_rules_article23_text2")}
                  </p>
                  <p className="mb-3">
                    ​{t("arbitration_society_rules_article23_text3")}
                  </p>
                  <ul className="list">
                    <li>​{t("arbitration_society_rules_article23_text4")}</li>
                    <li>​{t("arbitration_society_rules_article23_text5")}</li>
                  </ul>
                  <p className="mb-3">
                    ​{t("arbitration_society_rules_article23_text6")}
                  </p>
                  <p className="mb-3">
                    ​{t("arbitration_society_rules_article23_text7")}
                  </p>
                </CardBody>
              </Card>
            </UncontrolledCollapse>
          </div>
          <div className="item">
            <Button
              id="toggler27"
              style={{
                marginLeft: "20px",
                marginBottom: "1rem",
                backgroundColor: "white",
                border: "none",
                color: "gray",
                borderLeft: "10px solid #790b1b",
                borderRadius: "0px",
                height: "20px",
                paddingTop: "0px",
                width: "100%",
                textAlign: "start",
              }}
            >
              {t("arbitration_society_rules_article24")}
            </Button>
            <UncontrolledCollapse toggler="#toggler27">
              <Card>
                <CardBody className={"text-justify"}>
                  <p className="mb-3">
                    ​{t("arbitration_society_rules_article24_text1")}
                  </p>
                  <p className="mb-3">
                    ​{t("arbitration_society_rules_article24_text2")}
                  </p>
                  <p className="mb-3">
                    ​{t("arbitration_society_rules_article24_text3")}
                  </p>
                  <ul className="list">
                    <li>​{t("arbitration_society_rules_article24_text4")}</li>
                    <li>​{t("arbitration_society_rules_article24_text5")}</li>
                  </ul>
                  <p className="mb-3">
                    ​{t("arbitration_society_rules_article23_text6")}
                  </p>
                </CardBody>
              </Card>
            </UncontrolledCollapse>
          </div>
          <div className="item">
            <Button
              id="toggler28"
              style={{
                marginLeft: "20px",
                marginBottom: "1rem",
                backgroundColor: "white",
                border: "none",
                color: "gray",
                borderLeft: "10px solid #790b1b",
                borderRadius: "0px",
                height: "20px",
                paddingTop: "0px",
                width: "100%",
                textAlign: "start",
              }}
            >
              {t("arbitration_society_rules_article25")}
            </Button>
            <UncontrolledCollapse toggler="#toggler28">
              <Card>
                <CardBody className={"text-justify"}>
                  <p className="mb-3">
                    ​{t("arbitration_society_rules_article25_text1")}
                  </p>
                  <ul className="list">
                    <li>​{t("arbitration_society_rules_article25_text2")}</li>
                    <li>​{t("arbitration_society_rules_article25_text3")}</li>
                  </ul>
                  <p className="mb-3">
                    ​{t("arbitration_society_rules_article25_text4")}
                  </p>
                  <ul className="list">
                    <li>​{t("arbitration_society_rules_article25_text5")}</li>
                    <li>​{t("arbitration_society_rules_article25_text6")}</li>
                  </ul>
                  <p className="mb-3">
                    ​{t("arbitration_society_rules_article25_text7")}
                  </p>
                </CardBody>
              </Card>
            </UncontrolledCollapse>
          </div>
          <div className="item">
            <Button
              id="toggler29"
              style={{
                marginLeft: "20px",
                marginBottom: "1rem",
                backgroundColor: "white",
                border: "none",
                color: "gray",
                borderLeft: "10px solid #790b1b",
                borderRadius: "0px",
                height: "20px",
                paddingTop: "0px",
                width: "100%",
                textAlign: "start",
              }}
            >
              {t("arbitration_society_rules_article26")}
            </Button>
            <UncontrolledCollapse toggler="#toggler29">
              <Card>
                <CardBody className={"text-justify"}>
                  <p className="mb-3">
                    {t("arbitration_society_rules_article26_text1")}
                  </p>
                  <ul className="list">
                    <li>{t("arbitration_society_rules_article26_text2")}</li>
                    <li>{t("arbitration_society_rules_article26_text3")}</li>
                    <li>{t("arbitration_society_rules_article26_text4")}</li>
                    <li>{t("arbitration_society_rules_article26_text5")}</li>
                  </ul>
                  <p className="mb-3">
                    {t("arbitration_society_rules_article26_text6")}
                  </p>
                  <p className="mb-3">
                    {t("arbitration_society_rules_article26_text7")}
                  </p>
                </CardBody>
              </Card>
            </UncontrolledCollapse>
          </div>
          <div className="item">
            <Button
              id="toggler30"
              style={{
                marginLeft: "20px",
                marginBottom: "1rem",
                backgroundColor: "white",
                border: "none",
                color: "gray",
                borderLeft: "10px solid #790b1b",
                borderRadius: "0px",
                height: "20px",
                paddingTop: "0px",
                width: "100%",
                textAlign: "start",
              }}
            >
              {t("arbitration_society_rules_article27")}
            </Button>
            <UncontrolledCollapse toggler="#toggler30">
              <Card>
                <CardBody className={"text-justify"}>
                  <p className="mb-3">
                    {t("arbitration_society_rules_article27_text1")}
                  </p>
                  <p className="mb-3">
                    {t("arbitration_society_rules_article27_text2")}
                  </p>
                  <p className="mb-3">
                    {t("arbitration_society_rules_article27_text3")}
                  </p>
                </CardBody>
              </Card>
            </UncontrolledCollapse>
          </div>
          <div className="item">
            <Button
              id="toggler31"
              style={{
                marginLeft: "20px",
                marginBottom: "1rem",
                backgroundColor: "white",
                border: "none",
                color: "gray",
                borderLeft: "10px solid #790b1b",
                borderRadius: "0px",
                height: "20px",
                paddingTop: "0px",
                width: "100%",
                textAlign: "start",
              }}
            >
              {t("arbitration_society_rules_article28")}
            </Button>
            <UncontrolledCollapse toggler="#toggler31">
              <Card>
                <CardBody className={"text-justify"}>
                  <p className="mb-3">
                    {t("arbitration_society_rules_article28_text1")}
                  </p>
                  <p className="mb-3">
                    {t("arbitration_society_rules_article28_text2")}
                  </p>
                </CardBody>
              </Card>
            </UncontrolledCollapse>
          </div>
          <div className="item">
            <Button
              id="toggler32"
              style={{
                marginLeft: "20px",
                marginBottom: "1rem",
                backgroundColor: "white",
                border: "none",
                color: "gray",
                borderLeft: "10px solid #790b1b",
                borderRadius: "0px",
                height: "20px",
                paddingTop: "0px",
                width: "100%",
                textAlign: "start",
              }}
            >
              {t("arbitration_society_rules_article29")}
            </Button>
            <UncontrolledCollapse toggler="#toggler32">
              <Card>
                <CardBody className={"text-justify"}>
                  <p className="mb-3">
                    {t("arbitration_society_rules_article29_text1")}
                  </p>
                  <p className="mb-3">
                    {t("arbitration_society_rules_article29_text2")}
                  </p>
                </CardBody>
              </Card>
            </UncontrolledCollapse>
          </div>
          <div className="item">
            <Button
              id="toggler33"
              style={{
                marginLeft: "20px",
                marginBottom: "1rem",
                backgroundColor: "white",
                border: "none",
                color: "gray",
                borderLeft: "10px solid #790b1b",
                borderRadius: "0px",
                height: "20px",
                paddingTop: "0px",
                width: "100%",
                textAlign: "start",
              }}
            >
              {t("arbitration_society_rules_article30")}
            </Button>
            <UncontrolledCollapse toggler="#toggler33">
              <Card>
                <CardBody className={"text-justify"}>
                  <p className="mb-3">
                    {t("arbitration_society_rules_article30_text1")}
                  </p>
                  <p className="mb-3">
                    {t("arbitration_society_rules_article30_text2")}
                  </p>
                  <p className="mb-3">
                    {t("arbitration_society_rules_article30_text3")}
                  </p>
                  <p className="mb-3">
                    {t("arbitration_society_rules_article30_text4")}
                  </p>
                  <p className="mb-3">
                    {t("arbitration_society_rules_article30_text5")}
                  </p>
                  <p className="mb-3">
                    {t("arbitration_society_rules_article30_text6")}
                  </p>
                  <p className="mb-3">
                    {t("arbitration_society_rules_article30_text7")}
                  </p>
                  <p className="mb-3">
                    {t("arbitration_society_rules_article30_text8")}
                  </p>
                  <p className="mb-3">
                    {t("arbitration_society_rules_article30_text9")}
                  </p>
                  <p className="mb-3">
                    {t("arbitration_society_rules_article30_text10")}
                  </p>
                  <p className="mb-3">
                    {t("arbitration_society_rules_article30_text11")}
                  </p>
                  <p className="mb-3">
                    {t("arbitration_society_rules_article30_text12")}
                  </p>
                </CardBody>
              </Card>
            </UncontrolledCollapse>
          </div>
          <div className="item">
            <Button
              id="toggler34"
              style={{
                marginLeft: "20px",
                marginBottom: "1rem",
                backgroundColor: "white",
                border: "none",
                color: "gray",
                borderLeft: "10px solid #790b1b",
                borderRadius: "0px",
                height: "20px",
                paddingTop: "0px",
                width: "100%",
                textAlign: "start",
              }}
            >
              {t("arbitration_society_rules_article31")}
            </Button>
            <UncontrolledCollapse toggler="#toggler34">
              <Card>
                <CardBody className={"text-justify"}>
                  <p className="mb-3">
                    {t("arbitration_society_rules_article31_text1")}
                  </p>
                </CardBody>
              </Card>
            </UncontrolledCollapse>
          </div>
          <div className="item">
            <Button
              id="toggler35"
              style={{
                marginLeft: "20px",
                marginBottom: "1rem",
                backgroundColor: "white",
                border: "none",
                color: "gray",
                borderLeft: "10px solid #790b1b",
                borderRadius: "0px",
                height: "20px",
                paddingTop: "0px",
                width: "100%",
                textAlign: "start",
              }}
            >
              {t("arbitration_society_rules_article32")}
            </Button>
            <UncontrolledCollapse toggler="#toggler35">
              <Card>
                <CardBody className={"text-justify"}>
                  <p className="mb-3">
                    {t("arbitration_society_rules_article32_text1")}
                  </p>
                </CardBody>
              </Card>
            </UncontrolledCollapse>
          </div>
          <div className="item">
            <Button
              id="toggler37"
              style={{
                marginLeft: "20px",
                marginBottom: "1rem",
                backgroundColor: "white",
                border: "none",
                color: "gray",
                borderLeft: "10px solid #790b1b",
                borderRadius: "0px",
                height: "20px",
                paddingTop: "0px",
                width: "100%",
                textAlign: "start",
              }}
            >
              {t("arbitration_society_rules_schedule1")}
            </Button>
            <UncontrolledCollapse toggler="#toggler37">
              <Card>
                <CardBody className={"text-justify"}>
                  <p className="mb-3">
                    {t("arbitration_society_rules_schedule1_text1")}
                  </p>
                  <p className="mb-3">
                    {t("arbitration_society_rules_schedule1_text2")}
                  </p>
                  <p className="mb-3">
                    {t("arbitration_society_rules_schedule1_text3")}
                  </p>
                  <p className="mb-3">
                    {t("arbitration_society_rules_schedule1_text4")}
                  </p>
                  <p className="mb-3">
                    {t("arbitration_society_rules_schedule1_text5")}
                  </p>
                  <p className="mb-3">
                    {t("arbitration_society_rules_schedule1_text6")}
                  </p>
                  <p className="mb-3">
                    {t("arbitration_society_rules_schedule1_text7")}
                  </p>
                </CardBody>
              </Card>
            </UncontrolledCollapse>
          </div>
          <div className="item">
            <Button
              id="toggler38"
              style={{
                marginLeft: "20px",
                marginBottom: "1rem",
                backgroundColor: "white",
                border: "none",
                color: "gray",
                borderLeft: "10px solid #790b1b",
                borderRadius: "0px",
                height: "20px",
                paddingTop: "0px",
                width: "100%",
                textAlign: "start",
              }}
            >
              {t("arbitration_society_rules_schedule2")}
            </Button>
            <UncontrolledCollapse toggler="#toggler38">
              <Card>
                <CardBody className={"text-justify"}>
                  <p className="mb-3">
                    {t("arbitration_society_rules_schedule2_text1")}
                  </p>
                  <p className="mb-3">
                    {t("arbitration_society_rules_schedule2_text2")}
                  </p>
                  <ul className="list">
                    <li>{t("arbitration_society_rules_schedule2_text3")}</li>
                    <li>{t("arbitration_society_rules_schedule2_text4")}</li>
                    <li>{t("arbitration_society_rules_schedule2_text5")}</li>
                    <li>{t("arbitration_society_rules_schedule2_text6")}</li>
                    <li>{t("arbitration_society_rules_schedule2_text7")}</li>
                    <li>{t("arbitration_society_rules_schedule2_text8")}</li>
                    <li>{t("arbitration_society_rules_schedule2_text9")}</li>
                    <li>{t("arbitration_society_rules_schedule2_text10")}</li>
                  </ul>
                  <p className="mb-3">
                    {t("arbitration_society_rules_schedule2_text11")}
                  </p>
                  <p className="mb-3">
                    {t("arbitration_society_rules_schedule2_text12")}
                  </p>
                  <p className="mb-3">
                    {t("arbitration_society_rules_schedule2_text13")}
                  </p>
                  <p className="mb-3">
                    {t("arbitration_society_rules_schedule2_text14")}
                  </p>
                  <p className="mb-3">
                    {t("arbitration_society_rules_schedule2_text15")}
                  </p>
                  <p className="mb-3">
                    {t("arbitration_society_rules_schedule2_text16")}
                  </p>
                  <p className="mb-3">
                    {t("arbitration_society_rules_schedule2_text17")}
                  </p>
                  <p className="mb-3">
                    {t("arbitration_society_rules_schedule2_text18")}
                  </p>
                  <p className="mb-3">
                    {t("arbitration_society_rules_schedule2_text19")}
                  </p>
                  <p className="mb-3">
                    {t("arbitration_society_rules_schedule2_text20")}
                  </p>
                  <p className="mb-3">
                    {t("arbitration_society_rules_schedule2_text21")}
                  </p>
                  <p className="mb-3">
                    {t("arbitration_society_rules_schedule2_text22")}
                  </p>
                  <p className="mb-3">
                    {t("arbitration_society_rules_schedule2_text23")}
                  </p>
                  <ul className="list">
                    <li>{t("arbitration_society_rules_schedule2_text24")}</li>
                    <li>{t("arbitration_society_rules_schedule2_text25")}</li>
                    <li>{t("arbitration_society_rules_schedule2_text26")}</li>
                    <li>{t("arbitration_society_rules_schedule2_text27")}</li>
                  </ul>
                  <p className="mb-3">
                    {t("arbitration_society_rules_schedule2_text28")}
                  </p>
                  <p className="mb-3">
                    {t("arbitration_society_rules_schedule2_text29")}
                  </p>
                  <p className="mb-3">
                    {t("arbitration_society_rules_schedule2_text30")}
                  </p>
                  <ul className="list">
                    <li>{t("arbitration_society_rules_schedule2_text31")}</li>
                    <li>{t("arbitration_society_rules_schedule2_text32")}</li>
                    <li>{t("arbitration_society_rules_schedule2_text33")}</li>
                    <li>{t("arbitration_society_rules_schedule2_text34")}</li>
                  </ul>
                  <p className="mb-3">
                    {t("arbitration_society_rules_schedule2_text35")}
                  </p>
                  <p className="mb-3">
                    {t("arbitration_society_rules_schedule2_text36")}
                  </p>
                  <p className="mb-3">
                    {t("arbitration_society_rules_schedule2_text37")}
                  </p>
                  <p className="mb-3">
                    {t("arbitration_society_rules_schedule2_text38")}
                  </p>
                  <p className="mb-3">
                    {t("arbitration_society_rules_schedule2_text39")}
                  </p>
                </CardBody>
              </Card>
            </UncontrolledCollapse>

            <div className="mt-9 flex">
              <img src={PdfLogoImg} alt="" />
              <a
                className="ml-3"
                href="http://hkarbsoc.org.hk/HKASRulesV1.212.2221.pdf"
                download
              >
                {t("arbitration_society_rules_schedule2_text40")}
              </a>
            </div>
            <p className="mt-9">
              <span className="text-red-500">
                {t("arbitration_society_rules_schedule2_text41")}
              </span>{" "}
              {t("arbitration_society_rules_schedule2_text42")}
            </p>
          </div>
        </section>
      </main>
      <div className="temporary">
        <img src={BottomLogoImg} alt="" className="bottom-logo" />
      </div>

      <Footer />
    </>
  );
};

export default ArbitrationSocietyRulesPage;
